import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { GROUP_USER } from '../../../config/appGroupConfig';
import VenuesDashboard from './venues-dashboard';
import VendorDashboard from './vendor-dashboard';
import AdminDashboard from './admin-dashboard';

function Dashboard() {
  const { user } = useSelector((store) => store.users);
  const role = user?.role?.name;

  useEffect(() => {
    // Determine environment based on REACT_APP_STAGE
    const env = process.env.REACT_APP_STAGE || 'local';
    console.log(`Application Environment: ${env}`);
  }, []);

  switch (role) {
    case GROUP_USER.VENUE:
      return <VenuesDashboard />;
    case GROUP_USER.VENDOR:
      return <VendorDashboard />;
    case GROUP_USER.ADMIN:
      return <AdminDashboard />;
    default:
      return <VenuesDashboard />;
  }
}

export default Dashboard;
